import router from "./router";
import store from "./store";
import { getToken, setToken } from "@/utils/auth";
import { addQIYU } from '@/utils/qiyukf'
import { shareForward } from "@/api/login";

const loginList = [
  "/login",
  "/loginPhone",
  "/loginPhoneOther",
  "/loginPhonePassword",
  "/loginForget",
  "/loginPhoneCode",
];
const registerList = ["/register", "/registerInviteCode", "/registerPassword"];
const whiteList = [...loginList, ...registerList, '/read-article', '/alipayInWeixin', '/registerSuccessTip']

const getShareForward = (forwardId) => {
  return new Promise((resolve, reject) => {
    shareForward(forwardId)
      .then((res) => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      });
  });
};

router.beforeEach(async (to, from, next) => {
  // 处理小程序的登录逻辑
  console.log("beforeEach in permission p0")
  if (to.query?.token && to.query?.redirect) {
    setToken(to.query?.token)
    console.log("setToken and redirect")
    window.location.href = to.query.redirect;
  } else if (to.query?.mpbackflag && to.query?.redirect) {
    // 处理小程序那边注册失败，并且有上级id的客户自己进行登录。
    console.log("重定向 in permission")
    window.location.href = to.query.redirect;
  } else if (to.query?.token) {
    console.log("setToken and not redirect")
    setToken(to.query.token)
  } else if (to.query?.forwardId) {
    // 如果 query 中 有这个id会使用全局路由首位进行跳转。
    console.log("in permission forwardId logic")
    try {
      const { urlAddress } = await getShareForward(to.query.forwardId);
      if (urlAddress) {
        window.location.href = urlAddress;
      }
    } catch (error) { }
  }

  console.log("beforeEach in permission p2")

  let hasToken = getToken();
  if (hasToken) {
    console.log("hasToken")
    if (loginList.indexOf(to.path) !== -1) {
      next({
        path: "/",
      });
    } else {
      // 判断是否存在用户信息
      const customerId = store.state.user.customerId;
      const userInfoAccount = store.state.user.userInfoAccount;

      if (customerId && userInfoAccount) {
        next();
      } else {

        try {
          let distributionFlag;
          let id;
          try {
            const res = await store.dispatch("user/getUserInfo");  // url: '/user/introspect',
            distributionFlag = res.distributionFlag
            id = res.id
            console.log(res, "in permission.js")
            console.log("in permission", distributionFlag, id)
          } catch (error) {
            localStorage.setItem("trycatch0", error.stack)
          }
          try {
            localStorage.setItem("getUserInfoDetail_id", id)
            await store.dispatch('user/getUserInfoDetail', id) // 可能会出错 user/customer/:id 报错
          } catch (error) {
            localStorage.setItem("trycatch111", error.stack)
          }
          if (!distributionFlag) store.dispatch("app/accessStore");
          if (!distributionFlag && to.query.customerId) {
            // 如果不是分销，并且跳转目标是中有 customerId 那么则重新设置 客户的上级分销。
            await store.dispatch("user/updateStore", to.query.customerId);
          }
          const role = distributionFlag ? "distributor" : "customer";
          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            [role]
          );
          router.addRoutes(accessRoutes);
          // 增加客服
          addQIYU({
            uid: store.state.user.customerId,
            name: store.state.user.userInfoNickname,
            mobile: store.state.user.userInfoMobile,
          })
          store.dispatch('app/getMessageNumStart')
          next({ ...to, replace: true });
        } catch (error) {
          console.log("error in permission", error)
          localStorage.setItem("trycatch2", error.stack)
          // throw Error(error);
          await store.dispatch("user/resetToken");
          next({
            name: "Login",
            query: {
              redirect: to.path,
              ...to.query,
            },
          });
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 动态 path 的时候这里是无法添加白名单的。
      next();
    } else {
      next({
        name: "Login",
        query: {
          redirect: to.path,
          ...to.query,
        },
      });
    }
  }
  console.log("beforeEach in permission p3")
});
